import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { animalExtendedApi } from "../client/EntityApi";

const VaccineGroupSelect = (props: any) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    setLoading(true);
    animalExtendedApi
      .getCompanyVaccineGroups(props.companyId)
      .then((response) =>
        setGroups(
          response.map((item: any) => ({
            label: item.groupName,
            value: item.groupName,
            entity: item,
          }))
        )
      )
      .finally(() => setLoading(false));
  }, [props.companyId]);

  return (
    <Select
      {...props}
      options={groups}
      onSelect={props.onSelect}
      notFoundContent={loading ? <Spin size="small" /> : null}
    />
  );
};

export default VaccineGroupSelect;
